import { MagnificIframe } from '../types'

export default class popupGalery {
    init(): void {
        window.jQuery('.image-link').magnificPopup({ type: 'image' })
        window.jQuery('.popup-vimeo').magnificPopup({
            type: 'iframe',
            preloader: false,
            fixedContentPos: false
        })
    }

    extendMagnificIframe(): MagnificIframe {
        const iframe = {
            markup:
                '<div class="mfp-iframe-scaler">' +
                '<div id="iframeId" class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' +
                '</div>' +
                '<div class="mfp-bottom-bar">' +
                '<div class="mfp-title"></div>' +
                '</div>',
            patterns: {
                vimeo: {
                    index: 'vimeo.com/',
                    id: function (url) {
                        const m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/)
                        if (!m || !m[5]) return null

                        return m[5]
                    },
                    src: 'https://player.vimeo.com/video/%id%?autoplay=1'
                }
            }
        }

        return iframe
    }
}
